import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Star, ShoppingCart, Heart, Minus, Plus, Truck, Shield, Package } from 'lucide-react';
import { useCart } from '../context/CartContext';
export function ProductDetails() {
  const {
    id
  } = useParams();
  const {
    addToCart
  } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState('details');

  // Mock product data - in a real app this would come from an API
  const products = [{
    id: 1,
    name: 'Heritage Canvas Tote',
    price: '$25.00',
    numericPrice: 25,
    rating: 5,
    reviewCount: 24,
    img: 'https://images.unsplash.com/photo-1544816155-12df9643f363?q=80&w=2787&auto=format&fit=crop',
    images: ['https://images.unsplash.com/photo-1544816155-12df9643f363?q=80&w=2787&auto=format&fit=crop', 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?q=80&w=2787&auto=format&fit=crop'],
    cat: 'Heritage Apparel',
    description: 'A beautifully crafted canvas tote bag featuring traditional African patterns. Perfect for daily use, shopping, or as a statement piece.',
    details: 'Made from 100% organic cotton canvas. Dimensions: 15" x 16" x 6". Features reinforced handles and an interior pocket.'
  }, {
    id: 2,
    name: 'Wonder Boy Spice Blend',
    price: '$15.00',
    numericPrice: 15,
    rating: 5,
    reviewCount: 42,
    img: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=2940&auto=format&fit=crop',
    images: ['https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=2940&auto=format&fit=crop'],
    cat: 'Wonder Boy Restaurant Items',
    description: 'Our signature spice blend used in Wonder Boy Restaurant. Bring authentic African flavors to your home cooking.',
    details: '4oz jar. Ingredients: Paprika, cumin, coriander, ginger, garlic, cayenne pepper, and our secret blend of African spices.'
  }, {
    id: 3,
    name: 'Handwoven Basket',
    price: '$45.00',
    numericPrice: 45,
    rating: 4,
    reviewCount: 18,
    img: 'https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?q=80&w=2787&auto=format&fit=crop',
    images: ['https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?q=80&w=2787&auto=format&fit=crop'],
    cat: 'Cultural Crafts & Artwork',
    description: 'Handwoven by skilled artisans in West Africa. Each basket is unique and supports local craftspeople.',
    details: 'Approximately 12" diameter. Made from natural grass fibers. Fair trade certified.'
  }];
  const product = products.find(p => p.id === Number(id)) || products[0];
  const relatedProducts = products.filter(p => p.id !== product.id).slice(0, 3);
  const handleAddToCart = () => {
    for (let i = 0; i < quantity; i++) {
      addToCart(product);
    }
  };
  return <div className="pt-0 bg-warmwhite min-h-screen" data-id="element-1095" data-mp="4om9xjdoh2zx">
      {/* Breadcrumb */}
      <div className="bg-white border-b border-softgray py-4" data-id="element-1096" data-mp="3vvgnggpkjzxw">
        <div className="container mx-auto px-6 md:px-12" data-id="element-1097" data-mp="eg0azvla2av6">
          <div className="flex items-center gap-2 text-sm text-mediumgray" data-id="element-1098" data-mp="efgrwbjw5gfk">
            <Link to="/shop" className="hover:text-gold transition-colors" data-id="element-1099" data-mp="9hykwqpfpba7">Shop</Link>
            <span data-id="element-1100" data-mp="3hvxfpp0o6qm4">/</span>
            <span className="text-navy" data-id="element-1101" data-mp="3hx8tmhntxeqy">{product.name}</span>
          </div>
        </div>
      </div>

      {/* Product Details */}
      <section className="py-8 lg:py-16" data-id="element-1102" data-mp="3czyuubejvqqg">
        <div className="container mx-auto px-4 sm:px-6 md:px-12" data-id="element-1103" data-mp="3qxnfbi4pgvuz">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-16" data-id="element-1104" data-mp="3mvtkvrl3so39">
            {/* Left: Images */}
            <div className="w-full lg:w-1/2" data-id="element-1105" data-mp="166wfa7t9v76u">
              <div className="rounded-3xl overflow-hidden bg-white border border-softgray shadow-sm mb-4 lg:mb-6" data-id="element-1106" data-mp="165v6k9zqawsa">
                <img src={product.images[selectedImage]} alt={product.name} className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover" data-id="element-1107" data-mp="125b8933f5n4k" />
              </div>
              {product.images.length > 1 && <div className="flex gap-3 lg:gap-4 overflow-x-auto pb-2" data-id="element-1108" data-mp="26eur9cf74zg3">
                  {product.images.map((img, idx) => <button key={idx} onClick={() => setSelectedImage(idx)} className={`rounded-xl overflow-hidden border-2 transition-all shrink-0 ${selectedImage === idx ? 'border-gold' : 'border-softgray'}`} data-id="element-1109" data-mp="2bd629qh89fzw" data-mpi={idx}>
                      <img src={img} alt={`${product.name} ${idx + 1}`} className="w-20 h-20 lg:w-24 lg:h-24 object-cover" data-id="element-1110" data-mp="2p99s77l2j26k" />
                    </button>)}
                </div>}
            </div>

            {/* Right: Product Info */}
            <div className="w-full lg:w-1/2" data-id="element-1111" data-mp="344polj94fa64">
              <div className="text-xs font-bold text-gold uppercase tracking-wider mb-2" data-id="element-1112" data-mp="sgkvo57gvwxn">{product.cat}</div>
              <h1 className="text-3xl lg:text-4xl font-serif font-bold text-navy mb-4" data-id="element-1113" data-mp="nh89lmof6tw4">{product.name}</h1>
              
              <div className="flex items-center gap-4 mb-4 lg:mb-6" data-id="element-1114" data-mp="ijpypqque4lh">
                <div className="flex text-amber-400" data-id="element-1115" data-mp="djtrzjqrfz28">
                  {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 lg:w-5 lg:h-5 ${i < product.rating ? 'fill-current' : ''}`} data-id="element-1116" data-mp="1b7vjgdhwbtlb" data-mpi={i} />)}
                </div>
                <span className="text-mediumgray text-sm lg:text-base" data-id="element-1117" data-mp="1690zv9c3u105">({product.reviewCount} reviews)</span>
              </div>

              <div className="text-3xl lg:text-4xl font-bold text-gold mb-6 lg:mb-8" data-id="element-1118" data-mp="wify5d14wgd0">{product.price}</div>

              <p className="text-mediumgray text-base lg:text-lg leading-relaxed mb-6 lg:mb-8" data-id="element-1119" data-mp="1txk154wqldiq">{product.description}</p>

              <div className="flex items-center gap-4 mb-6 lg:mb-8" data-id="element-1120" data-mp="1p6vb7u0pgolp">
                <div className="flex items-center border border-softgray rounded-full bg-white" data-id="element-1121" data-mp="3jez56leiqpql">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center text-mediumgray hover:text-navy transition-colors" data-id="element-1122" data-mp="3oe255rfn65rp">
                    <Minus className="w-4 h-4" data-id="element-1123" data-mp="3emebrkziyenl" />
                  </button>
                  <span className="w-10 lg:w-12 text-center font-bold text-navy" data-id="element-1124" data-mp="30nepgjzhibul">{quantity}</span>
                  <button onClick={() => setQuantity(quantity + 1)} className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center text-mediumgray hover:text-navy transition-colors" data-id="element-1125" data-mp="34r4bb1oryfbx">
                    <Plus className="w-4 h-4" data-id="element-1126" data-mp="oyx66h9wxcsa" />
                  </button>
                </div>
              </div>

              <div className="flex gap-3 lg:gap-4 mb-8 lg:mb-10" data-id="element-1127" data-mp="txrlvacl2l86">
                <button onClick={handleAddToCart} className="flex-1 py-3 lg:py-4 bg-navy hover:bg-navy-light text-white rounded-xl font-bold transition-all shadow-md flex items-center justify-center gap-2 text-sm lg:text-base" data-id="element-1128" data-mp="tvxb2ov109ht">
                  <ShoppingCart className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-1129" data-mp="2o7f0e4j35jkn" /> Add to Cart
                </button>
                <button className="w-12 h-12 lg:w-14 lg:h-14 bg-warmwhite border border-softgray hover:border-gold hover:text-gold text-mediumgray rounded-xl transition-all flex items-center justify-center shrink-0" data-id="element-1130" data-mp="2jdu72psftdrs">
                  <Heart className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-1131" data-mp="2s9tfcdjmvz6n" />
                </button>
              </div>

              <div className="grid grid-cols-3 gap-2 lg:gap-4 p-4 lg:p-6 bg-white rounded-2xl border border-softgray" data-id="element-1132" data-mp="372ddezrxfgh8">
                <div className="text-center" data-id="element-1133" data-mp="1cqfa1egatet9">
                  <Truck className="w-6 h-6 text-gold mx-auto mb-2" data-id="element-1134" data-mp="1cr8eg8rsbs88" />
                  <div className="text-xs font-bold text-navy" data-id="element-1135" data-mp="17sdl4cw6yl9v">Free Shipping</div>
                  <div className="text-[10px] text-mediumgray" data-id="element-1136" data-mp="lyy9kbgv2g35">Orders over $50</div>
                </div>
                <div className="text-center" data-id="element-1137" data-mp="qwzoqlb61v9c">
                  <Shield className="w-6 h-6 text-gold mx-auto mb-2" data-id="element-1138" data-mp="qvoq0zwkvdp3" />
                  <div className="text-xs font-bold text-navy" data-id="element-1139" data-mp="vpas5y547z6n">Secure Payment</div>
                  <div className="text-[10px] text-mediumgray" data-id="element-1140" data-mp="10nm186nl65nt">100% Protected</div>
                </div>
                <div className="text-center" data-id="element-1141" data-mp="30dnixttu0wd">
                  <Package className="w-6 h-6 text-gold mx-auto mb-2" data-id="element-1142" data-mp="31oq4ubjd2lw" />
                  <div className="text-xs font-bold text-navy" data-id="element-1143" data-mp="7zgghjwj8gnz">Easy Returns</div>
                  <div className="text-[10px] text-mediumgray" data-id="element-1144" data-mp="cxi6kosdlg8y">30-day policy</div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="mt-12 lg:mt-20" data-id="element-1145" data-mp="1od6ubidgejat">
            <div className="flex gap-6 lg:gap-8 border-b border-softgray mb-6 lg:mb-8 overflow-x-auto pb-2" data-id="element-1146" data-mp="1ocdmee2rdnr3">
              {['details', 'reviews', 'shipping'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-2 lg:pb-4 font-bold capitalize transition-colors whitespace-nowrap ${activeTab === tab ? 'text-gold border-b-2 border-gold' : 'text-mediumgray hover:text-navy'}`} data-id="element-1147" data-mp="3cvhsoxtvgokm">
                  {tab}
                </button>)}
            </div>
            
            <div className="bg-white p-6 lg:p-8 rounded-3xl border border-softgray" data-id="element-1148" data-mp="2u6uoehjis383">
              {activeTab === 'details' && <div data-id="element-1149" data-mp="2p92vplb1wd2u">
                  <h3 className="text-xl lg:text-2xl font-bold text-navy mb-4" data-id="element-1150" data-mp="2l53k9h4mo4gc">Product Details</h3>
                  <p className="text-mediumgray leading-relaxed text-sm lg:text-base" data-id="element-1151" data-mp="2g6jwrcadyklv">{product.details}</p>
                </div>}
              {activeTab === 'reviews' && <div data-id="element-1152" data-mp="eexebz4k7y10">
                  <h3 className="text-xl lg:text-2xl font-bold text-navy mb-4" data-id="element-1153" data-mp="eedycnygzjpm">Customer Reviews</h3>
                  <p className="text-mediumgray text-sm lg:text-base" data-id="element-1154" data-mp="28sek4rnpq1uw">Reviews coming soon...</p>
                </div>}
              {activeTab === 'shipping' && <div data-id="element-1155" data-mp="2htm5k954r87k">
                  <h3 className="text-xl lg:text-2xl font-bold text-navy mb-4" data-id="element-1156" data-mp="2htumcc4dixo1">Shipping Information</h3>
                  <p className="text-mediumgray leading-relaxed text-sm lg:text-base" data-id="element-1157" data-mp="2cu9ne1p7epbb">Free standard shipping on orders over $50. Orders typically ship within 2-3 business days. Express shipping available at checkout.</p>
                </div>}
            </div>
          </div>

          {/* Related Products */}
          <div className="mt-16 lg:mt-20" data-id="element-1158" data-mp="1ywb9exesouwc">
            <h2 className="text-2xl lg:text-3xl font-serif font-bold text-navy mb-6 lg:mb-8" data-id="element-1159" data-mp="1u40b1yzpdh5w">You might also like...</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-1160" data-mp="16dxi7gnys768">
              {relatedProducts.map(relatedProduct => <Link key={relatedProduct.id} to={`/product/${relatedProduct.id}`} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-softgray hover:shadow-premium transition-all group" data-id="element-1161" data-mp="11d9vv8aokeic">
                  <div className="h-64 overflow-hidden relative bg-warmwhite" data-id="element-1162" data-mp="3hv96xlcajyns">
                    <img src={relatedProduct.img} alt={relatedProduct.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1163" data-mp="343un5cak7tfo" />
                  </div>
                  <div className="p-5" data-id="element-1164" data-mp="lt0hx0foe5g">
                    <h3 className="font-bold text-navy mb-2" data-id="element-1165" data-mp="4mmlahikxcu4">{relatedProduct.name}</h3>
                    <div className="text-gold font-bold" data-id="element-1166" data-mp="4kjuhv9lrfoc">{relatedProduct.price}</div>
                  </div>
                </Link>)}
            </div>
          </div>
        </div>
      </section>
    </div>;
}